import * as React from 'react';
import { useCallback } from 'react';
import { extractHtmlBlocks, getIframeContent, getIframeSrc, openFiddle } from '../../../../../services/mini/markdownHtmlExtractor';
import ToasterService from '../../../../../services/ToasterService';

function JsFiddleIcon() {
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1_2)">
            <path d="M17.4041 9.35697C17.4157 9.21023 17.4265 9.0654 17.4265 8.91674C17.4265 5.75824 14.8659 3.19824 11.7081 3.19824C9.40181 3.19824 7.41854 4.56763 6.51501 6.53425C6.0389 6.19718 5.45769 5.99597 4.82843 5.99597C3.21489 5.99597 1.90766 7.30385 1.90766 8.91738C1.90766 9.15896 1.94034 9.39285 1.99545 9.61777C0.806767 10.2669 0 11.5267 0 12.9768C0 15.0896 1.71222 16.8018 3.82429 16.8018C5.93637 16.8018 14.6237 16.8018 16.1757 16.8018C18.2878 16.8018 20 15.0896 20 12.9768C20.0013 11.2941 18.9138 9.86897 17.4041 9.35697ZM17.1811 12.6174C17.0504 14.0002 16.0886 15.4804 13.783 15.4804C12.0393 15.4804 10.381 13.6285 9.65749 12.6013C9.65557 12.5981 8.30605 10.5143 6.81234 10.5681C5.35132 10.6206 4.9662 11.3889 4.9002 12.0778C4.83483 12.766 5.22828 13.4747 5.85691 13.7996C6.64637 14.2046 7.63 13.956 8.62645 13.0922L9.60367 14.2232C8.64118 15.0562 7.61462 15.4843 6.64125 15.4849C6.13117 15.4849 5.63583 15.367 5.17189 15.128C3.99667 14.5218 3.28923 13.2402 3.4129 11.9381C3.54362 10.554 4.5061 9.07373 6.8117 9.07373C8.86931 9.07373 10.315 10.9462 10.7859 11.5998C11.5658 12.6846 12.9262 13.9867 13.7823 13.9867C15.2446 13.9867 15.6285 13.1646 15.6945 12.4764C15.7598 11.7888 15.3664 11.0794 14.7378 10.7552C13.9489 10.3502 12.9653 10.5995 11.9689 11.4626L10.9916 10.3323C12.4597 9.06284 14.0745 8.73283 15.4234 9.4281C16.5986 10.0337 17.3054 11.3153 17.1811 12.6174Z" fill="black" />
        </g>
        <defs>
            <clipPath id="clip0_1_2">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
}

type OpenJsFiddleButtonProps = {
    value: string
    width: number
    height: number
    className?: string
};

function OpenJsFiddleButton({ value, className, width, height }: OpenJsFiddleButtonProps) {
    const withHtml = extractHtmlBlocks(value)?.html?.length > 0;

    const iFrameUrl = getIframeSrc(value);

    const openHtmlInFiddleCb = useCallback(async () => {
        if (withHtml) {
            openFiddle(extractHtmlBlocks(value)?.html)
        }
        try {
            if (iFrameUrl) {
                openFiddle(await getIframeContent(iFrameUrl))
            }
        } catch (error) {
            console.error(error);
            ToasterService.showError({ title: 'There was a problem with the fetch operation for iframe. Please, contact support' })
        }


    }, [value, withHtml, iFrameUrl]);


    const shouldShowBtn = withHtml || iFrameUrl;

    const style = {} as { width: string, height: string };

    if (width) {
        style.width = `${width}px`;
    }
    if (height) {
        style.height = `${height}px`;
    }


    return <>
        {shouldShowBtn ?
            <div
                style={style}
                onClick={openHtmlInFiddleCb}
                title="Open html from the code blocks in JS Fiddle"
                className={`open-js-fiddle-btn ${className} `} >
                <JsFiddleIcon />
            </div> : <></>
        }
    </>
}

export default OpenJsFiddleButton;
